module.exports = __webpack_public_path__ + "media/photo/Group301-d6fe46e2.png";